import axios from 'axios';
import { create } from 'zustand';
import { useEffect } from 'react';

export const tokenStore = create((set) => ({
  sessionToken: localStorage.getItem('sessionToken') || '',
  refreshToken: localStorage.getItem('refreshToken') || '',
  isAuth: localStorage.getItem('isAuth') === 'true' || false,
  dataErrorMessage: '',

  getToken: async (body) => {
    set({
      sessionToken: '',
      refreshToken: '',
      isAuth: false,
      dataErrorMessage: '',
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SSO_URL}/v1/auth/login`,
        body,
        {
          headers: {
            'x-public-key': process.env.REACT_APP_SSO_ADMIN_PUBLIC_KEY,
          },
        }
      );

      set({
        sessionToken: response.data.access_token,
        refreshToken: response.data.refresh_token,
        isAuth: true,
        dataErrorMessage: '',
      });
    } catch (error) {
      set({
        sessionToken: '',
        isAuth: false,
        dataErrorMessage: error?.message,
      });
    }
  },

  // 15min
  setAccesToken: (value) => {
    set({ sessionToken: value });
  },

  setIsAuth: (value) => {
    set({ isAuth: value });
  },

  resetAuthValues: () => {
    set({
      sessionToken: '',
      refreshToken: '',
      isAuth: false,
      dataErrorMessage: '',
    });
  },
}));

export const useGetToken = () => {
  const {
    sessionToken,
    isAuth,
    refreshToken,
    resetAuthValues,
    setAccesToken,
    setIsAuth,
    getToken,
  } = tokenStore((state) => state);

  useEffect(() => {
    localStorage.setItem('sessionToken', sessionToken);
    localStorage.setItem('isAuth', JSON.stringify(isAuth));
    localStorage.setItem('refreshToken', refreshToken);
  }, [sessionToken, isAuth, refreshToken]);

  return {
    sessionToken,
    isAuth,
    refreshToken,
    resetAuthValues,
    setAccesToken,
    setIsAuth,
    getToken,
  };
};

export const { setAccesToken, resetAuthValues } = tokenStore.getState();
